// {Componente}{Verbo}{Acción}

export const SEND_EMAIL_POST_REQUEST = 'SEND_EMAIL_POST_REQUEST';
export const SEND_EMAIL_POST_SUCCESS = 'SEND_EMAIL_POST_SUCCESS';
export const SEND_EMAIL_POST_ERROR = 'SEND_EMAIL_POST_ERROR';
